import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link} from "react-router-dom";

import {toast} from "react-toastify";
import axios from "axios";

import IntlTelInput from 'react-intl-tel-input';
import 'libphonenumber-js-utils/dist/libphonenumber.js';
import Cookies from "js-cookie";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Signup extends Component {

    constructor(props) {
        super(props);
        this.state={
            website:"",
            name:"",
            nameInvalid:false,
            websiteInvalid:false,
            email:"",
            emailInvalid: false,
            password: "",
            loader: false,
            phoneInvalid: true,
            phoneValue: "",
            phoneNumber:"",
        }
        this.signup=this.signup.bind(this);
        this.signupEnter=this.signupEnter.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeWebsite = this.onChangeWebsite.bind(this);
        this.onChangeName = this.onChangeName.bind(this);
    }

    signupRequest(){


        if(!this.validate_name_surname(this.state.name)){
            toast.error("Invalid Name Surname");
            return false;
        }
        if(this.state.phoneInvalid===false){
            toast.error("Invalid Phone Number");
            return false;
        }
        if(this.state.websiteInvalid===true){
            toast.error("Invalid Website URL");
            return false;
        }
        if(!this.emailValidation(this.state.email)){
            toast.error("Invalid Email");
            return false;
        }

        this.setState({
            loader:true
        });
        const defaultHeaders = {
            'content-type' : 'application/x-www-form-urlencoded',
        }
        var _that=this;
        var formData = new FormData();
        formData.append("nameSurname", this.state.name);
        formData.append("email", this.state.email);
        formData.append("password", this.state.password);
        formData.append("website", this.state.website);

        if(this.state.phoneNumber!=""){
            formData.append("phoneNumber", this.state.phoneNumber);
        }


        axios.post(this.props.chatprop.url + "signup", formData, {
            headers: defaultHeaders,
        }).then((response) => {
            if (response.status === 200) {
                _that.setState({
                    loader:false
                });
                if (response.data.message.status == false) {
                    if (typeof response.data.message.error !== "undefined") {
                        $.each(response.data.message.error, function (k, v) {
                            toast.error(v);
                        });
                        return false;
                    }
                } else if (response.data.message.status == true) {
                    if (typeof response.data.message.success !== "undefined") {
                        if(typeof response.data.message.data.token!=="undefined"){
                            Cookies.set('hv_token',response.data.message.data.token);
                        }
                        window.location.reload();
                        return false;
                    }
                }

            }
        });
    }
    signupEnter(e){

        if (e.key === "Enter") {
            this.signupRequest();
        }
    }
    signup(){
        this.signupRequest();

    }
     validate_name_surname(name){
        var regName = /[a-zA-Z-ğüşöçİĞÜŞÖÇ]+ [a-zA-Z-ğüşöçİĞÜŞÖÇ]+$/;
        if(!regName.test(name)){
            return false;
        }else{
            return true;
        }
    }
     validateUrl(value) {
        return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
    }


    onChangeName(e){
        this.setState({
            name : e.target.value,
        });
        if(this.validate_name_surname(e.target.value)){
            this.setState({
                nameInvalid : false,
            });
        }else{
            this.setState({
                nameInvalid : true,
            });
        }
    }
    onChangeWebsite(e){
        this.setState({
            website : e.target.value,
        });

        var url=e.target.value.trim();
        if(url.length>0) {
            if (this.validateUrl(url)) {
                this.setState({
                    websiteInvalid: false
                });
            } else {
                this.setState({
                    websiteInvalid: true
                });
            }
        } else{
            this.setState({
                websiteInvalid: false
            });
        }
    }
    onChangeEmail(e) {
        if(this.emailValidation(e.target.value)){
            this.setState({
                email : e.target.value,
                emailInvalid:false
            });
        } else{
            this.setState({
                emailInvalid : true
            });

        }

    }
    onChangePassword(e){
        this.setState({
            password : e.target.value.trim(),
        });

    }
    emailValidation(email){
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if(!email || regex.test(email) === false){
            return false;
        }
        return true;
    }

    render() {
        const { t } = this.props;
        return (

            <div className="auth-wrap">
                <div className="auth-content">
                    <div className="auth-body auth-middle">
                        <div className="auth-logo pb-4 text-center">
                            <div className="auth-logo-wrap">
                                <img
                                    src={`/Public/images/logo-128-39.png`} alt="logo" />
                            </div>
                        </div>
                        <div className="auth-card auth-card-preview">
                            <div className="auth-card-inner auth-card-inner-lg">
                                <div className="auth-block-head">
                                    <div className="auth-block-head-title">Create Free Account</div>
                                    <div className="auth-block-head-description">

                                    </div>
                                </div>
                                <div className="auth-form-group">
                                    <div className="auth-label-group">
                                        <label className="auth-label">Name Surname</label>
                                    </div>
                                    <div className="auth-form-wrap">
                                        <input type="text"
                                               onChange={this.onChangeName.bind(this)}
                                               className="auth-form-control-lg auth-form-control"
                                               placeholder="Yaşar Demirtaş" />
                                        {this.state.nameInvalid === true &&
                                        <div className="auth-input-error">Invalid Name Surname</div>
                                        }
                                    </div>
                                </div>
                                <div className="auth-form-group">
                                    <div className="auth-label-group">
                                        <label className="auth-label">Email</label>
                                    </div>
                                    <div className="auth-form-wrap">
                                        <input type="text"
                                               onChange={this.onChangeEmail.bind(this)}
                                               onKeyPress={this.signupEnter}
                                               className="auth-form-control-lg auth-form-control"
                                               placeholder="ad@example.com" />
                                        {this.state.emailInvalid === true &&
                                        <div className="auth-input-error">Invalid Email</div>
                                        }
                                    </div>
                                </div>
                                <div className="auth-form-group">
                                    <div className="auth-label-group">
                                        <label className="auth-label">Password</label>
                                    </div>
                                    <div className="auth-form-wrap">
                                        <input type="password"
                                               onChange={this.onChangePassword.bind(this)}
                                               placeholder="******"
                                               onKeyPress={this.signupEnter}
                                               className="auth-form-control-lg auth-form-control"  />
                                    </div>
                                </div>
                                <div className="auth-form-group">
                                    <div className="auth-label-group">
                                        <label className="auth-label">Your company website</label>
                                    </div>
                                    <div className="auth-form-wrap">
                                        <input type="text"
                                               onChange={this.onChangeWebsite.bind(this)}
                                               onKeyPress={this.signupEnter}
                                               className="auth-form-control-lg auth-form-control"
                                               placeholder="https://www.mywebsite.com" />
                                        {this.state.websiteInvalid === true &&
                                        <div className="auth-input-error">Invalid Website</div>
                                        }
                                    </div>
                                </div>
                                <div className="auth-form-group">
                                    <div className="auth-label-group">
                                        <label className="auth-label">Phone Number</label>
                                    </div>
                                    <div className="auth-form-wrap">
                                        <IntlTelInput
                                            containerClassName="intl-tel-input"
                                            inputClassName="form-control"
                                            preferredCountries={['tr']}
                                            type="tel"
                                            utilsScript={"libphonenumber.js"}
                                            onPhoneNumberChange={(status, value, countryData, number, id) => {
                                                if(value.trim().length>0){
                                                    this.setState({
                                                        "phoneInvalid":status
                                                    });
                                                }else{
                                                    this.setState({
                                                        "phoneInvalid":true
                                                    });
                                                }
                                                this.setState({
                                                    "phoneValue":value
                                                });
                                                this.setState({
                                                    "phoneNumber":number
                                                });
                                            }}

                                        />
                                        {this.state.phoneInvalid === false &&
                                        <div className="auth-input-error">Invalid Phone</div>
                                        }
                                    </div>
                                </div>
                                <div className="auth-form-group">
                                    <button className="btn btn-primary btn-lg btn-block"
                                            disabled={this.state.loader}
                                            onClick={this.signup.bind(this)}
                                            onKeyPress={this.signupEnter}

                                            type="submit">
                                        {this.state.loader === true &&
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        }
                                        {this.state.loader === false &&
                                        <span>Signup</span>
                                        }
                                    </button>
                                </div>
                                <div className="auth-form-note text-center pt-4">
                                    Do you have an account ?&nbsp;<Link to={"/login"}>Login</Link>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div className="auth-footer">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center"><p
                                        className="auth-footer-text">© {new Date().getFullYear()} HelperVia. All Rights Reserved.</p></div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

export default Signup;
